import { render, staticRenderFns } from "./UserAction.vue?vue&type=template&id=7fcbc226&"
import script from "./UserAction.vue?vue&type=script&lang=js&"
export * from "./UserAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports